import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _NoveltyAccount, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { error } from "console";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Aprove: string;
}

export const SOLPER002 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};
    const procedure = configProcedure?._procedure ?? {};

    const { instance, bean, setBean } = useDataBean(_NoveltyAccount)

    const [response, setResponse] = useState<Resp>({
        Aprove: "",
        Obs: ""
    })

    useEffect(() => {
        if (props.IDNoveltyAccount) {
            instance.getNoveltyAccount(props.IDNoveltyAccount).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo Cargar la informacion de la solicitud, intentelo mas tarde") })
        }
    }, [props.IDNoveltyAccount])

    const onExportMap = () => {
        configProcedure?._pushInfo?.(response.Obs);

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ Approved: response.Aprove })
        }
    }


    const updateData = () => {
        if (response.Obs.trim().length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setResponse({ ...response, Aprove: "" })
            return;
        }


        const x = { ...bean, AproveDate: _single.getCurrenDate(), DescriptionResponse: response.Obs, State: response.Aprove == "true" ? 101 : 102 }
        instance.updateNoveltyAccount(x).then(
            (resp) => {
                onExportMap();
            }
        ).catch(err => { toast.error("No se pudo realizar la accion") })
    }


    useEffect(() => {
        if (response.Aprove !== "") {
            updateData();
        }
    }, [response]);

    const updateForm = (app: boolean) => {
        setResponse(prev => ({ ...prev, Aprove: `${app}` }));
    }



    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-12 mb-2">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton disable={!bean.IDNoveltyAccount} icon="ri-checkbox-circle-line" eventClick={() => { updateForm(true) }} >Aprobar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton disable={!bean.IDNoveltyAccount} icon="ri-close-circle-line" eventClick={() => { updateForm(false) }} >Rechazar</BasicButton>
                </div>
            </div>

        </>
    );
};